/* eslint-disable react/display-name */
import { ButtonHTMLAttributes, ReactNode, forwardRef } from 'react'

import * as Styled from './styles'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  variant?: string
  size?: string
  to?: string
  onClick?: () => void
}

const BaseButton = forwardRef<HTMLButtonElement, Props>(({ children, variant, onClick }, ref) => {
  return (
    <Styled.BaseButton variant={variant} ref={ref} onClick={onClick}>
      {children}
    </Styled.BaseButton>
  )
})

export default BaseButton
